import type { Variation } from 'src/modules/designStudio/helpers/productSelection/types';
import { useCommonTrackingData } from 'src/modules/designStudio/hooks/useCommonTrackingData';
import type { ButtonPressed } from 'src/shared/telemetry';

export const useTemplateTrackingData = () => {
  const commonTrackingData = useCommonTrackingData();

  return {
    commonTemplatesTrackingData: {
      ...commonTrackingData,
      primary_cta: false,
      design_studio_mode: 'default',
      feature: 'design_templates',
      button_location: 'design-template-panel',
    } as ButtonPressed,
    commonRealProductsTrackingData: {
      ...commonTrackingData,
      primary_cta: false,
      design_studio_mode: 'default',
      feature: 'Design Studio Products',
      button_location: 'design-template-panel',
    } as ButtonPressed,
    extractVariationTrackingData: (variation: Variation) => ({
      variation_uuid: variation.uuid,
      product_uuid: variation.product.uuid,
      provider_id: variation.product.provider.uuid,
      product_type: variation.product.type,
      product_size: variation.facets.sizing,
      product_color: variation.name,
      product_category: variation.product.type,
    }),
  };
};
